import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../styles/Login.scss";

const AdminSidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const user = JSON.parse(
        localStorage.getItem("user") ||
        sessionStorage.getItem("user") ||
        "{}"
    );

    const isAdmin = user.role === "admin";

    return (
        <aside className="admin-sidebar">

            <nav className="admin-nav">

                <button
                    type="button"
                    className={`admin-nav-item ${
                        location.pathname === "/admin-dashboard"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => navigate("/admin-dashboard")}
                >
                    <span className="admin-nav-icon">
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                d="M3 10.5L12 3L21 10.5V21H14.5V14.5H9.5V21H3V10.5Z"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>

                    <span>Welcome</span>
                </button>

                {isAdmin && (
                    <button
                        type="button"
                        className={`admin-nav-item ${
                            location.pathname === "/admin-users"
                                ? "active"
                                : ""
                        }`}
                        onClick={() => navigate("/admin-users")}
                    >
                        <span className="admin-nav-icon">
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path
                                    d="M16 21V19C16 16.7909 14.2091 15 12 15H6C3.79086 15 2 16.7909 2 19V21"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                                <circle
                                    cx="9"
                                    cy="7"
                                    r="4"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                />
                                <path
                                    d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M16 3.126C17.7252 3.5701 19 5.13616 19 7C19 8.86384 17.7252 10.4299 16 10.874"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </span>

                        <span>Users</span>
                    </button>
                )}

                <button
                    type="button"
                    className={`admin-nav-item ${
                        location.pathname === "/admin-page-headers"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => navigate("/admin-page-headers")}
                >
    <span className="admin-nav-icon">
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <rect
                x="3"
                y="4"
                width="18"
                height="16"
                rx="2"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path
                d="M3 9H21"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path
                d="M7 14H12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M7 17H16"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    </span>

                    <span>Page Headers</span>
                </button>
                <button
                    type="button"
                    className={`admin-nav-item ${
                        location.pathname === "/admin-home"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => navigate("/admin-home")}
                >
    <span className="admin-nav-icon">
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
    <rect
        x="3"
        y="4"
        width="18"
        height="16"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
    />
    <path
        d="M3 9H21"
        stroke="currentColor"
        strokeWidth="2"
    />
    <circle
        cx="7"
        cy="6.5"
        r="0.75"
        fill="currentColor"
    />
    <circle
        cx="10"
        cy="6.5"
        r="0.75"
        fill="currentColor"
    />
    <circle
        cx="13"
        cy="6.5"
        r="0.75"
        fill="currentColor"
    />
</svg>
    </span>

                    <span>Home Page</span>
                </button>
                <button
                    type="button"
                    className={`admin-nav-item ${
                        location.pathname === "/admin-about-us"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => navigate("/admin-about-us")}
                >
                    <span className="admin-nav-icon">
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="9"
                                stroke="currentColor"
                                strokeWidth="2"
                            />
                            <path
                                d="M12 11V17"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                            <circle
                                cx="12"
                                cy="7.5"
                                r="1"
                                fill="currentColor"
                            />
                        </svg>
                    </span>

                    <span>About Us</span>
                </button>
                <button
                    type="button"
                    className={`admin-nav-item ${
                        location.pathname === "/admin-products"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => navigate("/admin-products")}
                >
                    <span className="admin-nav-icon">
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <rect
                                x="8"
                                y="2"
                                width="8"
                                height="3"
                                rx="0.6"
                                stroke="currentColor"
                                strokeWidth="1.5"
                            />

                            <path
                                d="M9.5 5V6.5C9.5 7.2 9.2 7.7 8.7 8.1L7.5 9C6.7 9.6 6.2 10.5 6.2 11.5V20C6.2 21.1 7.1 22 8.2 22H15.8C16.9 22 17.8 21.1 17.8 20V11.5C17.8 10.5 17.3 9.6 16.5 9L15.3 8.1C14.8 7.7 14.5 7.2 14.5 6.5V5"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />

                            <rect
                                x="8"
                                y="11"
                                width="8"
                                height="7"
                                rx="0.5"
                                stroke="currentColor"
                                strokeWidth="1.2"
                            />

                            <path
                                d="M11.9 16.2C12.1 14.4 13.2 13.2 15 12.8C14.8 14.5 13.8 15.8 11.9 16.2Z"
                                stroke="currentColor"
                                strokeWidth="1"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />

                            <path
                                d="M11.9 16.2C11.8 14.9 11.1 14 10 13.5C10.1 14.8 10.7 15.8 11.9 16.2Z"
                                stroke="currentColor"
                                strokeWidth="1"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>

                    <span>Products</span>
                </button>
                <button
                    type="button"
                    className={`admin-nav-item ${
                        location.pathname === "/admin-how-to"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => navigate("/admin-how-to")}
                >
                    <span className="admin-nav-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect x="5" y="3" width="14" height="18" rx="2" />
                            <path d="M9 8h6" />
                            <path d="M9 12h6" />
                            <path d="M9 16h4" />
                        </svg>
                    </span>

                    <span>How To</span>
                </button>
                <button
                    type="button"
                    className={`admin-nav-item ${
                        location.pathname === "/admin-recipes"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => navigate("/admin-recipes")}
                >
                    <span className="admin-nav-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M4 19h16" />
                            <path d="M6 19V9" />
                            <path d="M18 19V9" />
                            <path d="M6 9h12" />
                            <path d="M8 9V5" />
                            <path d="M12 9V5" />
                            <path d="M16 9V5" />
                            <path d="M7 5h10" />
                        </svg>
                    </span>

                    <span>Recipes</span>
                </button>
                <button
                    type="button"
                    className={`admin-nav-item ${
                        location.pathname === "/admin-retailers"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => navigate("/admin-retailers")}
                >
                    <span className="admin-nav-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M6 8h12l1 12H5L6 8Z" />
                            <path d="M9 8V6a3 3 0 0 1 6 0v2" />
                        </svg>
                    </span>

                    <span>Retailers</span>
                </button>
                <button
                    type="button"
                    className={`admin-nav-item ${
                        location.pathname === "/admin-blogs"
                            ? "active"
                            : ""
                    }`}
                    onClick={() => navigate("/admin-blogs")}
                >
                    <span className="admin-nav-icon">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M5 3.5H14L19 8.5V20.5H5V3.5Z"
                                stroke="currentColor"
                                strokeWidth="1.8"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M14 3.5V8.5H19"
                                stroke="currentColor"
                                strokeWidth="1.8"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M8 12H16"
                                stroke="currentColor"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                            />
                            <path
                                d="M8 15.5H16"
                                stroke="currentColor"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                            />
                            <path
                                d="M8 9H11"
                                stroke="currentColor"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                            />
                        </svg>
                    </span>

                    <span>Blogs</span>
                </button>


            </nav>

        </aside>
    );
};

export default AdminSidebar;
